module.exports = __webpack_public_path__ + "dimer/static/img/19.c8c00e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/19.jpg
// module id = Iew8
// module chunks = 0